import Image from "@/components/Image";
import { ModalCenter } from "@/components/Modals/ModalCenter";
import { Link } from "react-router-dom";

export function ModalQRApp(props: { onClose: () => void }) {
  return (
    <ModalCenter
      isVisible={true}
      setIsVisible={() => {
        props.onClose();
      }}
      clickOutside={() => {
        props.onClose();
      }}
      title=""
      isHeader={false}
      className="!p-0 max-w-[420px]"
    >
      <div className="flex flex-col bg-white p-6 mx-2 rounded-2xl gap-x-2 gap-y-7 flex-wrap justify-between  pointer-events-auto">
        <p className="text-center font-bold">Download Holdstation App</p>
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
          <div className="w-40 h-40">
            <Image
              src={require("@/assets/images/logo-scan.webp")}
              alt="QR app"
              width={1200}
              height={1200}
            />
          </div>
          <div className="flex flex-row sm:flex-col gap-2">
            <Link
              to={
                "https://apps.apple.com/us/app/holdstation-web3-wallet/id6444925618"
              }
              target="_blank"
              className="flex gap-2 items-center justify-center text-white bg-black/80 rounded-full px-6 py-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
              >
                <title>App Store</title>
                <g clipPath="url(#clip0_1676_5570)">
                  <path
                    d="M13.0642 6.6865L13.8087 6.38069C14.4141 6.1396 15.1955 5.89536 16.1192 6.05062C18.01 6.36842 19.3145 7.3894 20.0914 8.7436C20.3908 9.26548 20.1489 9.95293 19.5887 10.1724C18.6569 10.5373 17.9999 11.4439 17.9999 12.5014C17.9999 13.6091 18.7211 14.5511 19.7222 14.8783C20.2405 15.0478 20.5317 15.6231 20.3615 16.1411C19.9201 17.4838 19.2836 18.7227 18.5305 19.7227C17.7871 20.71 16.879 21.531 15.868 21.9312C15.2088 22.1921 14.5002 22.0947 13.8227 21.9266L13.4206 21.8195L12.8237 21.6461C12.5528 21.5678 12.2747 21.4997 11.9999 21.4997C11.7251 21.4997 11.447 21.5678 11.1761 21.6461L10.5793 21.8195L10.1772 21.9266C9.49961 22.0947 8.79107 22.1921 8.13188 21.9312C6.85861 21.4272 5.73553 20.2512 4.88738 18.8648C4.02419 17.4537 3.37005 15.7042 3.10335 13.8789C2.87624 12.3244 2.99884 10.5799 3.71813 9.10325C4.45891 7.58252 5.81382 6.39806 7.8806 6.05062C8.72039 5.90945 9.44255 6.09848 10.0218 6.31515L10.352 6.44605L10.9357 6.68651C11.3354 6.84313 11.6515 6.93536 11.9999 6.93536C12.3484 6.93536 12.6645 6.84312 13.0642 6.6865ZM11.7677 2.76913C12.744 1.79282 14.2426 1.70847 14.5961 2.06203C14.9497 2.41558 14.8653 3.91414 13.889 4.89045C12.9127 5.86676 11.4141 5.95111 11.0606 5.59756C10.707 5.24401 10.7914 3.74544 11.7677 2.76913Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1676_5570">
                    <rect width={24} height={24} fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>App Store</span>
            </Link>
            <Link
              to={
                "https://play.google.com/store/apps/details?id=io.holdstation"
              }
              target="_blank"
              className="flex gap-2 items-center justify-center text-white bg-black/80 rounded-full px-6 py-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
              >
                <title>Google Play</title>
                <g clipPath="url(#clip0_1676_5578)">
                  <path
                    d="M11.9999 13.4126L14.9467 16.3593L5.25 21.9577C4.72369 22.2616 4.12812 22.2057 3.68198 21.916L3.57369 21.8388L11.9999 13.4126ZM3 4.41269L10.5857 11.9984L3 19.5841V4.41269ZM16.7398 8.67278L20.25 10.6994C21.25 11.2767 21.25 12.7201 20.25 13.2974L16.7398 15.324L13.4142 11.9984L16.7398 8.67278ZM5.25 2.03914L14.9466 7.6375L11.9999 10.5842L3.57371 2.15798C4.02839 1.80308 4.67983 1.70995 5.25 2.03914Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1676_5578">
                    <rect width={24} height={24} fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>Google Play</span>
            </Link>
          </div>
        </div>
      </div>
    </ModalCenter>
  );
}
